// config.js
// const config = {
//     appName:'Chart',
//     appVersion:'v1.0.6',
//     appUrl: 'https://charts.dev.aihconweb.com',
//     patientServerUrl: 'https://patient.dev.aihconweb.com',
//     apiServerUrl: 'https://api.dev.aihconweb.com',
//     chartServerUrl: 'https://chart-backend.dev.aihconweb.com',
// }

const config = {
    appName:'Charting',
    appVersion:'v1.0.7',
    appUrl: 'https://charting.doc.pro',
    patientServerUrl: 'https://patient.dev.aihconweb.com',
    apiServerUrl: 'https://api.dev.aihconweb.com',
    chartServerUrl: 'https://chart-backend.dev.aihconweb.com',
}

// const config = {
//     appName:'Chart',
//     appVersion:'v1.0.6',
//     appUrl: 'http://localhost:3000',
//     patientServerUrl: 'https://patient.dev.aihconweb.com',
//     apiServerUrl: 'https://api.dev.aihconweb.com',
//     chartServerUrl: 'https://chart-backend.dev.aihconweb.com',
// }


// const config = {
//     appName:'Chart',
//     appVersion:'v1.0.6',
//     appUrl: 'http://localhost:3000',
//     patientServerUrl: 'http://127.0.0.1:8001',
//     apiServerUrl: 'http://127.0.0.1:8002',
//     chartServerUrl: 'http://127.0.0.1:8003',
// }
  
export default config;
  